
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 .333a3.332 3.332 0 013.333 3.334 3.332 3.332 0 11-6.666 0A3.332 3.332 0 017 .333zm0 8.334c3.683 0 6.667 1.491 6.667 3.333v1.667H.333V12c0-1.842 2.984-3.333 6.667-3.333z","fill":"#263238"}})])
          )
        }
      }
    